import { useState, useEffect, useRef, useCallback } from 'react';

export const useScrollHeader = (threshold = 10) => {
  const [isAtTop, setIsAtTop] = useState(true);
  const [isVisible, setIsVisible] = useState(true);

  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  const updateScrollState = useCallback(() => {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY.current;
    const atTop = currentScrollY <= threshold;

    setIsAtTop(atTop);
    if (atTop && lastScrollY.current !== 0) {
      setIsVisible(true);
    } else {
      if (scrollDelta < -5) {
        setIsVisible(true);
      } else if (scrollDelta > 5) {
        setIsVisible(false);
      }
    }

    lastScrollY.current = currentScrollY;
    ticking.current = false;
  }, [threshold]);

  const onScroll = useCallback(() => {
    if (!ticking.current) {
      window.requestAnimationFrame(updateScrollState);
      ticking.current = true;
    }
  }, [updateScrollState]);

  useEffect(() => {
    lastScrollY.current = window.scrollY;
    const atTop = window.scrollY <= threshold;
    setIsAtTop(atTop);

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll, threshold]);

  return {
    isAtTop,
    isVisible,
  };
};
